<mat-form-field subscriptSizing="dynamic">
    <mat-label>Start date</mat-label>
    <mat-select [(value)]="monthSelected" (valueChange)="onChange($event)" [disabled]="isDisabled">
        <mat-option *ngFor="let month of months" [value]="month['id']">
            {{ month['name'] }}
        </mat-option>
    </mat-select>
</mat-form-field>
